import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=d7a578cc&"
import script from "./TextEditor.vue?vue&type=script&lang=js&"
export * from "./TextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7a578cc')) {
      api.createRecord('d7a578cc', component.options)
    } else {
      api.reload('d7a578cc', component.options)
    }
    module.hot.accept("./TextEditor.vue?vue&type=template&id=d7a578cc&", function () {
      api.rerender('d7a578cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/comments/TextEditor.vue"
export default component.exports